'use client';

import { c as _c } from "react/compiler-runtime";
import type { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { isSponsorshipInTransition } from '@sola/shared-utils/supporters/commitments.ts';
import { useSponsorships } from '@sola/supporter-sdk/hooks/commitments.ts';
export type TransitionDepartureAlertData = {
  childName?: string;
  count: number;
};
export const getTransitionDepartureAlertData = (sponsorships: GraphQLCommitment[], childGlobalId?: string): TransitionDepartureAlertData | undefined => {
  const transitionSponsorships = sponsorships.filter(sponsorship => isSponsorshipInTransition(sponsorship) && (!childGlobalId || sponsorship.participant?.globalId === childGlobalId));
  if (transitionSponsorships.length === 0) {
    return;
  }
  return {
    childName: transitionSponsorships.length === 1 ? transitionSponsorships[0]?.participant?.name ?? undefined : undefined,
    count: transitionSponsorships.length
  };
};
export const useTransitionDepartureAlert = childGlobalId => {
  const $ = _c(3);
  const sponsorshipsQuery = useSponsorships();
  const isLoading = sponsorshipsQuery.isLoading || sponsorshipsQuery.isFetching || sponsorshipsQuery.isPending;
  if (isLoading || sponsorshipsQuery.isError) {
    return;
  }
  let t0;
  if ($[0] !== childGlobalId || $[1] !== sponsorshipsQuery.sponsorships) {
    t0 = getTransitionDepartureAlertData(sponsorshipsQuery.sponsorships, childGlobalId);
    $[0] = childGlobalId;
    $[1] = sponsorshipsQuery.sponsorships;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};